import { useQuery } from "@tanstack/react-query";

import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import apiClient from "@app/common/api/apiClient";
import { isResponseErrorWithStatus } from "@app/common/utils";

const usePreviewInvoice = ({
  delta,
  enabled,
}: {
  delta: number;
  enabled: boolean;
}) => {
  const { billingAccount } = useBillingContext();

  const previewInvoiceQuery = useQuery({
    queryKey: ["billing", "previewInvoice", delta],
    queryFn: async () => {
      if (!billingAccount?.id) throw new Error("No billing account");
      try {
        const invoice = await apiClient.billing.createPreviewInvoice(
          billingAccount.id,
          delta
        );
        return { invoice };
      } catch (error) {
        if (isResponseErrorWithStatus(error, 422)) {
          return { error: "over_transaction_limit" };
        }
        if (isResponseErrorWithStatus(error, 400)) {
          return { error: "invalid_quantity" };
        }
        throw error;
      }
    },
    enabled,
  });

  return {
    isError: previewInvoiceQuery.isError,
    isLoading: previewInvoiceQuery.isLoading,
    previewInvoice: previewInvoiceQuery.data?.invoice,
    previewInvoiceError: previewInvoiceQuery.data?.error,
  };
};

export default usePreviewInvoice;
